import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';
import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
  SwitchFieldProps,
  TextFieldProps,
} from '../../../../components/form-builder/form-builder.types';
import { BankDetailsRepository } from '../../../../store/bank-details-state/bank-details-state.repository';

interface getBankDetailsFormStructureProps {
  store: BankDetailsRepository;
  bankDetailsCountryOptions?: SelectOption[];
}

export const getBankDetailsFormStructure = ({ store, bankDetailsCountryOptions }: getBankDetailsFormStructureProps): DynamicForm => {
  const nomColumn: DynamicField<TextFieldProps> = {
    label: 'settings.bankDetails.form.name.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'nom'),
      onChange: (value: string) => store.setNested('dto', 'nom', value),
    },
  };
  const agenceColumn: DynamicField<TextFieldProps> = {
    label: 'settings.bankDetails.form.agency.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'agence'),
      onChange: (value: string) => store.setNested('dto', 'agence', value),
    },
  };
  const ribColumn: DynamicField<TextFieldProps> = {
    label: 'settings.bankDetails.form.rib.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'rib'),
      onChange: (value: string) => store.setNested('dto', 'rib', value),
    },
  };
  const paysColumn: DynamicField<SelectFieldProps> = {
    label: 'settings.bankDetails.form.country.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'settings.bankDetails.form.country.placeholder',
      options: bankDetailsCountryOptions,
      value: store.getObservable<SelectOption>('bankDetailsCountrySelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNested('dto', 'paysId', value.code);
        store.setNested('bankDetailsCountrySelected', value);
      },
    },
  };

  const localColumn: DynamicField<SwitchFieldProps> = {
    label: 'settings.bankDetails.form.local.label',
    variant: FieldVariant.SWITCH,
    isRequired: true,
    props: {
      placeholder: 'settings.bankDetails.form.local.placeholder',
      checked: store.getNestedObservable<boolean>('dto', 'local'),
      onChange: (value: ToggleSwitchChangeEvent) => store.setNested('dto', 'local', value.checked),
    },
  };

  return {
    title: 'Détails du compte bancaire',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [nomColumn],
          },
          {
            fields: [agenceColumn, ribColumn],
          },
          {
            fields: [paysColumn],
          },
          {
            fields: [localColumn],
          },
        ],
      },
    ],
  };
};
